import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tooltip-toggle" }

import Tooltip from "@/components/shared/Tooltip.vue";
import Icon from "@/components/shared/Icon.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'InfoTooltip',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tooltip, { location: "bottom" }, {
    toggle: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(Icon, { icon: "info" })
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "tooltipText", {}, () => [
        _cache[0] || (_cache[0] = _createTextVNode(" Shalom from the tooltip! ", -1))
      ])
    ]),
    _: 3
  }))
}
}

})